module.exports = __webpack_public_path__ + "static/media/ni.45b81131.svg";